async function GetChopperByID (chopperid) {

    if (chopperid) {

            let response;

            let params = {
                "@ChopperID": chopperid
              };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "154", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "TrimChoppers", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default GetChopperByID;